import { type Product } from '@wix/ambassador-forms-v4-form/types';

export const PRODUCT_PRICE_MULTIPLE_OF = 0.01;

export function getProductPrice(product?: Product): string {
  return product?.fixedPriceOptions?.price || '0';
}
